'use client';

import { User } from '@prisma/client';
import { useSession } from 'next-auth/react';
import { createContext, SetStateAction, useState, Dispatch, useContext, useEffect } from 'react';

type UserContextType = {
  user: User;
  setUser: Dispatch<SetStateAction<User>>;
};

export const UserContext = createContext({} as UserContextType);

export function UserProvider({ children }) {
  const [user, setUser] = useState<User>(null);

  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === 'authenticated') {
      setUser(session.user);
    }
  }, [session]);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export const useUserContext = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useLocationContext must be used within an LocalizationProvider');
  }

  return context;
};
